import React, { useState, useEffect } from 'react';
import '../../Assets/Css/ProfileEdit.css';
import { useNavigate } from 'react-router-dom';
import DropdownIcon from '../../Assets/Images/SVG/logdownIcon.svg';
import backIcon from "../../Assets/Images/Expand_left.png";
import TLCalendar from "../../Assets/Images/SVG/testlog-calendar.svg";
import TickIcon from '../../Assets/Images/Done_ring_round_fill.png';
import config from '../../Config';

const ProfileEdit = () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    gender: '',
    dob: '',
    email: '',
    mobile_no: '',
    height: '',
    weight: '',
    bloodGroup: '',
    profilePic: null,
  });

  useEffect(() => {
    const fetchProfile = async () => {
      const token = sessionStorage.getItem('authToken');
      const patientid = sessionStorage.getItem('patientid');

      if (!token || !patientid) {
        navigate('/signin');
        return;
      }

      try {
        const response = await fetch(`${config.API_BASE_URL}/patient/profile/${patientid}`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch profile: ${response.statusText}`);
        }

        const data = await response.json();
        const { id, name, gender, dob, mail, mobile_no, height, weight, blood_group } = data.data;

        setFormData({
          id,
          name,
          gender,
          dob,
          email: mail,
          mobile_no: mobile_no,
          height,
          weight,
          bloodGroup: blood_group,
          profilePic: null,
        });
      } catch (error) {
        console.error('Error fetching profile:', error);
      }
    };

    fetchProfile();
  }, [navigate]);

  const handleSave = async () => {
    const token = sessionStorage.getItem('authToken');
    const patientid = sessionStorage.getItem('patientid');

    if (!token || !patientid) {
      navigate('/signin');
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append('id', formData.id);
    formDataToSend.append('name', formData.name);
    formDataToSend.append('gender', formData.gender);
    formDataToSend.append('dob', formData.dob);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('mobile_no', formData.mobile_no);
    formDataToSend.append('height', formData.height);
    formDataToSend.append('weight', formData.weight);
    formDataToSend.append('blood_group', formData.bloodGroup);

    if (formData.profilePic) {
      formDataToSend.append('profile_pic', formData.profilePic);
    }

    try {
      const response = await fetch(`${config.API_BASE_URL}/patient/profile`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formDataToSend,
      });

      if (!response.ok) {
        throw new Error(`Failed to update profile: ${response.statusText}`);
      }

      const data = await response.json();
      console.log(data);
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);
    } catch (error) {
      console.error('Error saving profile:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, profilePic: file });
  };

  return (
    <div className="profile-edit-container">
      <div className="profile-edit-header">
        <button className="profile-edit-back-button" onClick={() => navigate('/profile')}>
          <img src={backIcon} alt="Back" className="profile-back-icon" />
        </button>
        <h1 className="profile-title">Profile</h1>
      </div>

      <div className="profile-edit-form">
        <div className="profile-form-group">
          <label className="profile-label">Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            placeholder="Enter Name"
            className="profile-input"
          />
        </div>

        <div className="profile-form-group">
          <label className="profile-label">Gender</label>
          <div className="profile-custom-select">
            <select
              name="gender"
              value={formData.gender}
              onChange={handleInputChange}
              className="profile-select"
            >
              <option value="" disabled>Select</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
            <img src={DropdownIcon} alt="Dropdown" className="profile-dropdown-icon" />
          </div>
        </div>

        <div className="profile-form-group">
          <label className="profile-label">Date of Birth</label>
          <div className="profile-date-input">
            <input
              type="text"
              name="dob"
              value={formData.dob}
              onChange={handleInputChange}
              placeholder="20-07-1990"
              className="profile-input"
            />
            <img src={TLCalendar} alt="Calendar" className="profile-calendar-icon" />
          </div>
        </div>

        <div className="profile-form-group">
          <label className="profile-label">Email ID</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            placeholder="nameab@gmail.com"
            className="profile-input"
          />
        </div>

        <div className="profile-form-group">
          <label className="profile-label">Contact</label>
          <input
            type="text"
            name="mobile_no"
            value={formData.mobile_no}
            onChange={handleInputChange}
            placeholder="+91 123 456 7891"
            className="profile-input disabled-input"
            disabled
          />
        </div>

        <h2 className="profile-subheading">Medical Profile</h2>

        <div className="profile-form-group">
          <label className="profile-label">Height (cm)</label>
          <input
            type="number"
            name="height"
            value={formData.height}
            onChange={handleInputChange}
            placeholder="170"
            className="profile-input"
          />
        </div>

        <div className="profile-form-group">
          <label className="profile-label">Weight (kg)</label>
          <input
            type="number"
            name="weight"
            value={formData.weight}
            onChange={handleInputChange}
            placeholder="90"
            className="profile-input"
          />
        </div>

        <div className="profile-form-group">
          <label className="profile-label">Blood Group</label>
          <div className="profile-custom-select">
            <select
              name="bloodGroup"
              value={formData.bloodGroup}
              onChange={handleInputChange}
              className="profile-select"
            >
              <option value="" disabled>Select</option>
              <option value="A Positive">A Positive</option>
              <option value="B Positive">B Positive</option>
              <option value="O Positive">O Positive</option>
              <option value="AB Negative">AB Negative</option>
            </select>
            <img src={DropdownIcon} alt="Dropdown" className="profile-dropdown-icon" />
          </div>
        </div>

        <div className="profile-form-group">
          <label className="profile-label">Profile Picture</label>
          <input
            type="file"
            onChange={handleFileChange}
            className="profile-input"
          />
        </div>

        <button className="profile-save-button" onClick={handleSave}>
          Save
        </button>
      </div>

      {showPopup && (
        <div className="profile-popup">
          <div className="profile-popup-content">
            <img src={TickIcon} alt="Success" className="profile-popup-icon" />
            <p className="profile-popup-text">Your profile has been updated successfully</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileEdit;
